import React from 'react'
import styles from './EdofSection10.module.css'
const EdofSection10 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <img src='/Images/men_on_phone.webp' alt='men_on_phone' loading="lazy" decoding="async" />
                </div>
                <div className={styles.RightSection}>
                    <h2>Benefits</h2>
                    <h3>For patients and practice</h3>
                    <p>Deseyne Extended Depth of Focus (EDOF) daily disposable contact lenses offer a new treatment solution for presbyopic patients, featuring FDA-cleared technology that has demonstrated a statistically significant increase in depth of focus of +0.78 D  vs the control lens.</p>
                    <p>The technology delivers continuous focus at near vision (40 cm) with a 1.6-line improvement and at intermediate distances (66 cm) with a 1.5-line improvement, while preserving distance vision without a multifocal design and the adaptation associated with simultaneous vision.</p>
                    <p>FusionTechnology™ and LacriMass™ provide all-day wearability.</p>
                </div>
                <div className={styles.TobImgGraphic}>
                    <img src='/Images/section10_graphic.png' alt='section10_graphic' loading="lazy" decoding="async" />
                </div>


            </div>
        </div>
    )
}

export default EdofSection10
